import { QueryClient } from '@tanstack/react-query';

/**
 * The app's single TanStack query client.
 *
 * Extracted from `src/app/index.tsx` so non-component code can reach the same
 * cache — specifically the Redux bootstrap thunk, which now fetches the current
 * user *through* this client instead of calling `http` directly. That is what
 * lets `useCurrentUser()` and app boot share one `GET /me` rather than issuing
 * one each.
 *
 * Module scope on purpose: rebuilding it in a component body would throw the
 * whole cache away on every re-render of `App`.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0, refetchOnWindowFocus: false } },
});
